// Puente entre las rutas del sitio y el sitio público: la página va en la ruta
// y lo elegido en los selectores en `?picks=`. Lo usan las rutas de la app
// (`/s/$slug`, `/s/$slug/$page`) y las del subdominio del sitio (`/`,
// `/$page`, ver site-host-app.tsx); los enlaces salen de lib/sites/paths.ts.

import { useMemo } from "react";
import { useNavigate } from "@tanstack/react-router";
import { sitePagePath } from "@/lib/sites/paths";
import PublicSiteView from "./public-site-view";
import { parsePicks, serializePicks, type SitePicks } from "./picks";

export const siteSearch = (search: Record<string, unknown>): { picks?: string } => {
  const picks = serializePicks(parsePicks(search.picks));
  return picks ? { picks } : {};
};

export interface SiteRouteProps {
  slug: string;
  page?: string;
  picks?: string;
  /** `true` en el subdominio del sitio (enlaces `/<página>`); si no, `/s/<slug>/<página>`. */
  onSiteHost?: boolean;
}

export function SiteRoute({ slug, page, picks: rawPicks, onSiteHost = false }: SiteRouteProps) {
  const navigate = useNavigate();
  const picks = useMemo(() => parsePicks(rawPicks), [rawPicks]);
  const hrefFor = (to: string, next: SitePicks) =>
    sitePagePath({ slug, page: to, picks: serializePicks(next), onSiteHost });
  return (
    <PublicSiteView
      key={slug}
      slug={slug}
      page={page}
      picks={picks}
      hrefFor={hrefFor}
      onNavigate={({ page: to, picks: next }) =>
        void navigate({
          href: hrefFor(to, next),
          // Cambiar lo elegido en la misma página no llena el historial.
          replace: to === page,
          resetScroll: to !== page,
        })
      }
    />
  );
}
